import { put, call, fork, take } from 'redux-saga/effects';

import { REQUEST } from 'redux-config/reduxHelpers';
import { acceptError } from 'common/_redux';

import * as api from '../api';
import * as ActionTypes from './actions';

export function* boGetUserChallengesSaga({ search }) {
  try {
    const { status, data } = yield call(api.boGetUserChallenges, search);

    if (status < 300) {
      yield put(ActionTypes.boGetUserChallenges.success(data));
    } else {
      yield put(ActionTypes.boGetUserChallenges.failure(data.detail));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.boGetUserChallenges.failure());
    throw e;
  }
}

export function* boGetUserChallengesWatcherSaga() {
  while (true) {
    const { search } = yield take(ActionTypes.BO_GET_USER_CHALLENGES[REQUEST]);
    yield call(boGetUserChallengesSaga, search);
  }
}

export function* boGetUserChallengeSaga(challengeId) {
  try {
    const { status, data } = yield call(api.boGetUserChallenge, challengeId);

    if (status < 300) {
      yield put(ActionTypes.boGetUserChallenge.success(data));
    } else {
      yield put(ActionTypes.boGetUserChallenge.failure(data.detail));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.boGetUserChallenge.failure());
    throw e;
  }
}

export function* boGetUserChallengeWatcherSaga() {
  while (true) {
    const { challengeId } = yield take(ActionTypes.BO_GET_USER_CHALLENGE[REQUEST]);
    yield call(boGetUserChallengeSaga, challengeId);
  }
}

export function* boIncreaseUserChallengeSaga(challengeId) {
  try {
    const { status, data } = yield call(api.boIncreaseUserChallenge, challengeId);

    if (status < 300) {
      yield put(ActionTypes.boIncreaseUserChallenge.success());
      yield call(boGetUserChallengeSaga, challengeId);
    } else {
      const error = data.detail || data.error || data;
      yield put(acceptError(error));
      yield put(ActionTypes.boIncreaseUserChallenge.failure());
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.boIncreaseUserChallenge.failure());
  }
}

export function* boIncreaseUserChallengeWatcherSaga() {
  while (true) {
    const { challengeId } = yield take(ActionTypes.BO_INCREASE_USER_CHALLENGE[REQUEST]);

    yield call(boIncreaseUserChallengeSaga, challengeId);
  }
}

export function* boCloseUserChallengeSaga(challengeId, reason) {
  try {
    const { status, data } = yield call(api.boCloseUserChallenge, challengeId, reason);

    if (status < 300) {
      yield put(ActionTypes.boCloseUserChallenge.success());
      yield call(boGetUserChallengeSaga, challengeId);
    } else {
      yield put(ActionTypes.boCloseUserChallenge.failure(data.detail));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.boCloseUserChallenge.failure());
    throw e;
  }
}

export function* boCloseUserChallengeWatcherSaga() {
  while (true) {
    const { challengeId, reason } = yield take(ActionTypes.BO_CLOSE_USER_CHALLENGE[REQUEST]);

    yield call(boCloseUserChallengeSaga, challengeId, reason);
  }
}

export default [
  fork(boGetUserChallengesWatcherSaga),
  fork(boGetUserChallengeWatcherSaga),
  fork(boIncreaseUserChallengeWatcherSaga),
  fork(boCloseUserChallengeWatcherSaga),
];
